<script setup>
import {computed} from "vue";
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    status: String,
    rename: {
        type: Object,
        default: null,
    },
    size: {
        type: String,
        default: 'text-base'
    },
    lowercaseText: {
        type: String,
        default: 'lowercase'
    },
    fontWidthText: {
        type: String,
        default: 'font-semibold'
    }
})

const arrOrderStatus = computed(() => {
    return {
        paid: {"value": "paid", "label": trans('Paid')},
        refunded: {"value": "refunded", "label": trans('Refunded')},
        finished: {"value": "finished", "label": trans('Completed')},
        cancelled: {"value": "cancelled", "label": trans('Canceled')},
        new: {"value": "new", "label": trans('New')}
    }
})

if (props.rename) {
    arrOrderStatus.value[props.rename.value] = props.rename
}

const statusObject = computed(() => {
   return arrOrderStatus.value[props.status]
})

const color = computed(() => {
    return statusObject.value.value === 'paid' || statusObject.value.value === 'finished' ? 'text-green-600' : statusObject.value.value === 'new' ? 'text-blue-600' : 'text-red-500'
})

</script>

<template>
    <span :class="[size, lowercaseText, fontWidthText, color]" class="leading-120">{{statusObject.label}}</span>
</template>

<style scoped>

</style>
